import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import LocationAddButton from "@/modules/location/location-add-button";
import LocationsListProvider from "@/modules/locations/locations-list-provider";
import LocationsListTable from "@/modules/locations/locations-list-table";

const LocationsListPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader title={t("navigation:locations")} />
      <AppLayoutPage>
        <LocationsListProvider storageKey={STORAGE_KEYS.LOCATIONS}>
          <LocationsListTable extraActions={<LocationAddButton />} />
        </LocationsListProvider>
      </AppLayoutPage>
    </>
  );
};

export default LocationsListPage;
